import React, { useState, useCallback } from 'react';
import { Dropdown, Menu } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

import OnTraccrButton from './OnTraccrButton';
import colors from '../../constants/Colors';

const OVERLAY_STYLE = {
  borderRadius: 6,
  overflow: 'hidden',
  border: '1px solid #E5E7EB',
  marginTop: 4,
  boxShadow: '0px 4px 4.8px 0px #00000033',
};

const MENU_ITEM_STYLE = { color: colors.GRAY_950, fontSize: 14 };

function OnTraccrButtonDropdown({
  buttonTitle,
  menuItems = [],
  onMenuClick,
  overlay,
  overlayStyle,
  menuItemStyle,
  showOpenCloseIcon = true,
  trigger,
  buttonStyle,
  ...dropdownProps
}) {
  const [isOpen, setIsOpen] = useState(false);

  const handleMenuClick = useCallback((info) => {
    info.domEvent?.stopPropagation();
    setIsOpen(false);
    onMenuClick?.(info);
  }, [onMenuClick]);

  const mergedOverlayStyle = { ...OVERLAY_STYLE, ...overlayStyle };
  const mergedMenuItemStyle = { ...MENU_ITEM_STYLE, ...menuItemStyle };

  const menuContent = overlay === undefined
    ? (
      <Menu onClick={handleMenuClick}>
        {menuItems.map(({ key, label, disabled }) => (
          <Menu.Item key={key} disabled={disabled} style={mergedMenuItemStyle}>
            {label}
          </Menu.Item>
        ))}
      </Menu>
    ) : (
      overlay
    );

  let icon = null;

  if (showOpenCloseIcon) {
    icon = isOpen ? <UpOutlined /> : <DownOutlined />;
  }

  const defaultTrigger = (
    <OnTraccrButton
      title={buttonTitle}
      icon={icon}
      style={buttonStyle}
      onClick={(e) => e.stopPropagation()}
    />
  );

  return (
    <Dropdown
      overlay={menuContent}
      trigger={['click']}
      overlayStyle={mergedOverlayStyle}
      onVisibleChange={setIsOpen}
      visible={isOpen}
      {...dropdownProps} // eslint-disable-line react/jsx-props-no-spreading
    >
      {trigger === undefined ? defaultTrigger : trigger}
    </Dropdown>
  );
}

/* eslint-disable react/forbid-prop-types */
OnTraccrButtonDropdown.propTypes = {
  buttonTitle: PropTypes.string,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      disabled: PropTypes.bool,
    }),
  ),
  onMenuClick: PropTypes.func,
  overlay: PropTypes.node,
  overlayStyle: PropTypes.object,
  menuItemStyle: PropTypes.object,
  showOpenCloseIcon: PropTypes.bool,
  trigger: PropTypes.node,
  buttonStyle: PropTypes.object,
};

OnTraccrButtonDropdown.defaultProps = {
  buttonTitle: '',
  menuItems: [],
  onMenuClick: undefined,
  overlay: undefined,
  overlayStyle: undefined,
  menuItemStyle: undefined,
  showOpenCloseIcon: true,
  trigger: undefined,
  buttonStyle: undefined,
};

export default OnTraccrButtonDropdown;
